import React from "react"
import PropTypes from "prop-types"
import { Box, Typography } from "@mui/material"

const StatusIconBadge = ({ label, color = "warning", iconColor, icon }) => {
    const finalIconColor = iconColor || color
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                backgroundColor: "transparent", 
                padding: 0,
            }}
        >

            <Box
                sx={{
                    display: "flex",
                    color: (theme) => theme.palette[finalIconColor]?.main || color,
                    "& svg": { width: 28, height: 30 } 
                }}
            >
                {icon}
            </Box>

            <Typography
                variant="subtitle1"
                sx={{
                    color: (theme) => theme.palette[color]?.main || color,
                    textTransform: "uppercase",
                    fontWeight: 350,
                    letterSpacing: "0.05em",
                }}
            >
                {label}
            </Typography>
        </Box>
    )
}

StatusIconBadge.propTypes = {
    label: PropTypes.string.isRequired,
    color: PropTypes.string,
    iconColor: PropTypes.string,
    icon: PropTypes.node.isRequired,
}

export default StatusIconBadge